module.exports = __webpack_public_path__ + "static/media/5.62dc016a.png";